





























































































































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import { base64DownloadFile } from "@/utils/exportFile";
import { imageUrl } from '@/utils/common'

@Component({
    name: "pointsMXListShare"
})
export default class extends Vue {

    openOrderInfo(orderno: string) {
        this.mxDialog = false;
        this.$router.push({
            path: "/shop/listDetail",
            query: {
                orderNo: orderno,
            },
        });
    }
    mx: any = {
        activityId: '',
        rewardRecordId: '',
        keyword: '',
        rewardType: '',
        integralStatus: '',
        pagination: {
            page: 0,
            pageSize: 10,
        }
    }
    mxDialog = false
    mxLoading = false
    mxTotal = 0
    mxTable = []
    closeMXDialog() {
        this.mxDialog = false;
    }

    searchMXTable(search = false) {
        this.mxLoading = true;
        if (search) {
            this.mx.pagination = {
                pageSize: 10,
                page: 0,
            };
        }
        this.mx.activityId = this.$route.query.id;
        api
            .post('J27799', this.mx)
            .then(res => {
                this.mxTotal = res.total;
                this.mxTable = res.list;
            }).finally(() => {
                this.mxLoading = false;
            })
    }

    changeMX(page: any) {
        this.mx.pagination.page = page - 1;
        this.searchMXTable();
    }


    name = ''
    // 表格数据
    tableData = [];
    // 加载状态
    loading = false;
    // 总条数
    total = 0;
    // 搜索条件
    search: any = {
        activityId: '',
        auditStatus: '',
        memberLevel: '',
        keyword: '',
        auditTimes: [],
        participateTimes: [],
        pagination: {
            page: 0, //页码，从0开始
            pageSize: 20, //每页数量
        },
    };

    auditDialog = false
    audit = {
        recordId: '',
        auditResult: 1,
        auditImages: "",
        auditRemark: ''
    }
    baseUrl = imageUrl
    fileList: any = []
    dataAuth = {}
    handleAvatarRemove(file: any, fileList: any) {
        const index = this.fileList.findIndex((item: any) => item.key === file.response.data);
        if (index !== -1) {
            this.fileList.splice(index, 1);
        }
    }
    handleAvatarSuccess(res: any, file: any) {
        this.sureLoading = false
        console.log('file', file, res);
        if (res.errcode == 0) {
            this.fileList.push({
                name: file.name,
                key: res.data
            })
        } else {
            this.$message.error('上传失败')
        }
    }
    beforeAvatarUpload(file: any) {
        return new Promise((resolve, reject) => {
            const isImg = file.type === "image/jpeg" || file.type === "image/png";
            const isSize = file.size / 1024 < 500;
            if (!isImg) {
                this.$message.error("上传图片只能是 JPG/PNG 格式!");
            }
            if (!isSize) {
                this.$message.error("上传图片大小不能超过 500KB!");
            }
            if (isImg && isSize) {
                api
                    .post("J27501", {
                        fileName: file.name,
                        softLink: ''
                    })
                    .then((data) => {
                        this.dataAuth = data;
                        this.sureLoading = true
                        resolve(true);
                    })
                    .catch(() => {
                        reject(false);
                    });
            } else {
                reject(false);
            }
        });
    }
    sureLoading = false
    sureAudit() {
        console.log(this.fileList);
        if (this.fileList.length > 0) {
            this.audit.auditImages = JSON.stringify(this.fileList);
        }
        this.sureLoading = true
        api.post('J27797', this.audit).then(res => {
            this.auditDialog = false
            this.searchTable();
        }).finally(() => {
            this.sureLoading = false
        })
    }

    toAudit(row: any) {
        this.audit = {
            recordId: row.id,
            auditResult: 1,
            auditImages: "",
            auditRemark: ''
        }
        this.fileList = [];
        this.auditDialog = true;
    }

    closeAuditDialog(done: Function) {
        if (this.$refs.uploadRef) {
            (this.$refs.uploadRef as any).clearFiles()
        }
        this.auditDialog = false
        done()
    }
    auditJG = {}
    auditLoading = false
    toAuditJG(row: any) {
        api
            .post("J27798", {
                id: row.id
            })
            .then((data) => {
                this.auditJG = data
                this.fileList = [];
                if (data.auditImages) {
                    this.fileList = JSON.parse(data.auditImages);
                }
                this.auditJGDialog = true
            })
    }

    auditJGDialog = false
    closeAuditJGDialog() {
        this.auditJGDialog = false
    }

    toMing(row: any) {
        this.mx.rewardRecordId = row.id;
        this.searchMXTable();
        this.mxDialog = true
    }

    vipList = []
    getVIPList() {
        api
            .post("J27142")
            .then((data) => {
                this.vipList = data.list
            })
    }

    exportLoading = false
    exportD() {
        this.exportLoading = true
        api.post('J27796', this.search).then(res => {
            base64DownloadFile(res.fileName, res.fileBase64)
        }).finally(() => {
            this.exportLoading = false
        })
    }


    // 搜索 search:true 重置翻页
    searchTable(search = false) {
        this.loading = true;
        if (search) {
            this.search.pagination = {
                pageSize: 20,
                page: 0,
            };
        }
        this.search.activityId = this.$route.query.id
        api
            .post('J27795', this.search)
            .then(res => {
                this.total = res.total;
                this.tableData = res.list;
            }).finally(() => {
                this.loading = false;
            })
    }


    config = {}
    getConfig() {
        api.getJavaConfig().then((res) => {
            this.config = res;
        });
    }

    activityType: any = ''
    activated() {
        this.name = this.$route.query.name as string;
        this.activityType = this.$route.query.activityType
        this.getConfig();
        this.getVIPList();
        this.searchTable();
    }
}
